<template>
  <agent-default>
    <div class="ps-shell">

      <header class="ps-topbar">
        <div class="ps-topbar-left">
          <button class="ps-back" @click="goTo('AgentDashboard', 'product_select_back')">
            <v-icon color="#184679" size="15">mdi-arrow-left</v-icon>
          </button>
          <div class="ps-breadcrumb">
            <span class="ps-bc-dim">New Quote</span>
            <span class="ps-bc-sep">/</span>
            <span class="ps-bc-active">Select Product</span>
          </div>
        </div>
        <!-- <span class="ps-step-pill">Step 1 of 3</span> -->
      </header>

      <div class="ps-hero">
        <h1 class="ps-hero-title">Select a product</h1>
        <p class="ps-hero-sub">Live pricing is generated instantly once you choose.</p>
      </div>

      <div class="ps-grid">

        <!-- Motor — LIVE -->
        <div class="ps-card ps-card--live">
          <div class="card-header">
            <div class="card-icon-wrap">
              <i class="ph ph-car card-ph-icon"></i>
            </div>
            <span class="badge-live">
              <span class="live-dot"></span>Live
            </span>
          </div>
          <div class="card-body" @click="goTo('AgentUnderwriting', 'product_select_motor_card')">
            <p class="card-name">Motor Insurance</p>
            <p class="card-desc">Private &amp; commercial vehicles. Comprehensive &amp; TPO.</p>
          </div>
          <div class="card-tags">
            <span class="tag tag--light">Comprehensive</span>
            <span class="tag tag--light">Third Party</span>
          </div>
          <div class="card-actions">
            <button class="card-cta card-cta--secondary" @click="goTo('AgentUnderwriting', 'product_select_generate_quote')">
              Generate Quote
            </button>
            <button class="card-cta" @click="goTo('AgentSale', 'product_select_instant_buy', { journey: 'direct' })">
              Instant Buy
              <i class="ph ph-lightning tw-ml-1"></i>
            </button>
          </div>
        </div>

        <!-- Travel — LIVE -->
        <div class="ps-card ps-card--live ps-card--travel">
          <div class="card-header">
            <div class="card-icon-wrap card-icon-wrap--sky">
              <i class="ph ph-airplane-tilt card-ph-icon card-ph-icon--sky"></i>
            </div>
            <span class="badge-live">
              <span class="live-dot"></span>Live
            </span>
          </div>
          <div class="card-body" @click="goTo('AgentTravelPlanSelect', 'product_select_travel_card')">
            <p class="card-name">Travel Insurance</p>
            <p class="card-desc">International travel cover for individuals and families.</p>
          </div>
          <div class="card-tags">
            <span class="tag tag--light">Europe</span>
            <span class="tag tag--light">Worldwide</span>
          </div>
          <div class="card-actions">
            <button class="card-cta card-cta--secondary" @click="goTo('AgentTravelPlanSelect', 'product_select_travel_quote')">
              Generate Quote
            </button>
            <button class="card-cta" @click="goTo('AgentTravelPlanSelect', 'product_select_travel_instant', { journey: 'direct' })">
              Instant Buy
              <i class="ph ph-lightning tw-ml-1"></i>
            </button>
          </div>
        </div>

        <!-- Personal Accident — LIVE -->
        <div class="ps-card ps-card--live">
          <div class="card-header">
            <div class="card-icon-wrap">
              <i class="ph ph-first-aid card-ph-icon"></i>
            </div>
            <span class="badge-live">
              <span class="live-dot"></span>Live
            </span>
          </div>
          <div class="card-body" @click="goTo('AgentPaPlanSelect', 'product_select_pa_card')">
            <p class="card-name">Personal Accident</p>
            <p class="card-desc">Students on attachment. Accidental death, disability &amp; medical benefits.</p>
          </div>
          <div class="card-tags">
            <span class="tag tag--light">Option 1–3</span>
            <span class="tag tag--light">3 / 6 / 12 mo</span>
          </div>
          <div class="card-actions">
            <button class="card-cta card-cta--secondary" @click="goTo('AgentPaPlanSelect', 'product_select_pa_quote')">
              Generate Quote
            </button>
            <button class="card-cta" @click="goTo('AgentPaPlanSelect', 'product_select_pa_instant', { journey: 'direct' })">
              Instant Buy
              <i class="ph ph-lightning tw-ml-1"></i>
            </button>
          </div>
        </div>

        <!-- SME — SOON -->
        <div class="ps-card ps-card--soon ps-card--sme">
          <div class="card-header">
            <div class="card-icon-wrap card-icon-wrap--green">
              <i class="ph ph-briefcase card-ph-icon card-ph-icon--green"></i>
            </div>
            <span class="badge-soon">
              <i class="ph ph-lock-simple"></i>Soon
            </span>
          </div>
          <div class="card-body">
            <p class="card-name card-name--dark">SME Package</p>
            <p class="card-desc card-desc--sub">Tailored business protection for small &amp; medium enterprises in Kenya.</p>
          </div>
          <div class="card-tags">
            <span class="tag tag--green">Fire &amp; Perils</span>
            <span class="tag tag--green">Liability</span>
          </div>
          <div class="soon-footer">
            <i class="ph ph-bell"></i>
            Notify me when live
          </div>
        </div>

      </div>

      <p class="ps-tip">
        <i class="ph ph-info"></i>
        Quotes auto-save to your pipeline. New products roll out progressively.
      </p>

    </div>
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import { mapGetters } from 'vuex';
import { trackAgentInteraction } from '@/utils/agentAnalytics';

export default {
  name: 'AgentProductSelect',
  components: { AgentDefault },
  computed: { ...mapGetters('auth', ['authenticatedUser']) },
  methods: {
    goTo(name, action, query) {
      trackAgentInteraction(this, action, { destination: name });
      this.$router.push({ name, query });
    },
  },
  metaInfo: { title: 'New Quote — Select Product' },
};
</script>

<style scoped>

.ps-shell {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 24px;
  box-sizing: border-box;
}

/* ── TOPBAR ── */
.ps-topbar {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 20px;
}
.ps-topbar-left { display: flex; align-items: center; gap: 10px; }
.ps-back {
  width: 30px; height: 30px; border-radius: 50%;
  border: 1px solid #E2E8F0; background: white;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.ps-back:hover { border-color: #184679; box-shadow: 0 0 0 3px rgba(24,70,121,0.08); }
.ps-breadcrumb { display: flex; align-items: center; gap: 6px; font-size: 0.78rem; }
.ps-bc-dim    { color: #94A3B8; }
.ps-bc-sep    { color: #CBD5E1; }
.ps-bc-active { color: #184679; font-weight: 600; }
.ps-step-pill {
  font-size: 0.68rem; font-weight: 600;
  color: #2BABE2;
  background: rgba(43,171,226,0.08);
  border: 1px solid rgba(43,171,226,0.2);
  padding: 4px 12px; border-radius: 20px;
}

/* ── HERO ── */
.ps-hero { margin-bottom: 24px; }
.ps-hero-title {
  font-size: 1.4rem; font-weight: 700;
  color: #184679; margin: 0 0 4px; letter-spacing: -0.3px;
}
.ps-hero-sub { color: #718096; font-size: 0.85rem; margin: 0; }

/* ── GRID ── */
.ps-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

/* ── CARD BASE ── */
.ps-card {
  border-radius: 14px; padding: 20px;
  display: flex; flex-direction: column; gap: 14px;
  text-align: left; box-sizing: border-box; min-height: 235px;
  transition: transform 0.2s, box-shadow 0.2s;
}

/* ── LIVE CARD ── */
.ps-card--live {
  cursor: pointer;
  background: linear-gradient(135deg, #184679 0%, #112F56 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(24,70,121,0.25);
}
.ps-card--live:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 32px rgba(24,70,121,0.35);
}
.ps-card--live:active { transform: translateY(-1px); }

/* ── SOON CARDS — colored borders per product ── */
.ps-card--soon {
  cursor: default;
  background: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.ps-card--domestic { border: 1.5px solid #BAE6FD; }
.ps-card--sme      { border: 1.5px solid #BBF7D0; }

/* ── CARD HEADER ── */
.card-header { display: flex; align-items: center; justify-content: space-between; }

/* Live icon */
.card-icon-wrap {
  width: 42px; height: 42px; border-radius: 11px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
}
.card-ph-icon { font-size: 20px; color: rgba(255,255,255,0.9); }

/* Colored icon variants — mirrors dashboard stat-icon style */
.card-icon-wrap--sky   { background: #E0F2FE; border-color: #BAE6FD; }
.card-icon-wrap--amber { background: #FEF3C7; border-color: #FDE68A; }
.card-icon-wrap--green { background: #DCFCE7; border-color: #BBF7D0; }

.card-ph-icon--sky   { color: #0284C7; }
.card-ph-icon--amber { color: #D97706; }
.card-ph-icon--green { color: #16A34A; }

/* ── BADGES ── */
.badge-live {
  display: inline-flex; align-items: center; gap: 6px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.22);
  color: rgba(255,255,255,0.9);
  font-size: 0.65rem; font-weight: 700;
  padding: 3px 10px; border-radius: 20px;
}
.live-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: #4ADE80; box-shadow: 0 0 6px rgba(74,222,128,0.7);
  animation: livePulse 2s ease-in-out infinite;
}
@keyframes livePulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(1.5); }
}
.badge-soon {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.64rem; font-weight: 600;
  color: #94A3B8; background: #F8FAFC;
  border: 1px solid #E2E8F0;
  padding: 3px 10px; border-radius: 20px;
}
.badge-soon .ph { font-size: 10px; }

/* ── CARD BODY ── */
.card-body { flex: 1; }
.card-name {
  font-size: 1.05rem; font-weight: 700;
  color: white; margin: 0 0 6px; letter-spacing: -0.2px;
}
.card-name--dark  { color: #1E293B; }
.card-desc { font-size: 0.76rem; line-height: 1.6; color: rgba(255,255,255,0.55); margin: 0; }
.card-desc--sub   { color: #64748B; }

/* ── TAGS ── */
.card-tags { display: flex; flex-wrap: wrap; gap: 5px; }
.tag { font-size: 0.62rem; font-weight: 600; padding: 3px 9px; border-radius: 20px; }
.tag--light { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.75); border: 1px solid rgba(255,255,255,0.15); }
.tag--sky   { background: #E0F2FE; color: #0284C7; border: 1px solid #BAE6FD; }
.tag--amber { background: #FEF3C7; color: #B45309; border: 1px solid #FDE68A; }
.tag--green { background: #DCFCE7; color: #15803D; border: 1px solid #BBF7D0; }

/* ── CTA ── */
.card-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.card-cta {
  display: flex; align-items: center; justify-content: center;
  background: #2BABE2; color: white;
  font-size: 0.78rem; font-weight: 700;
  padding: 10px 12px; border-radius: 10px;
  transition: background 0.15s;
  border: none; cursor: pointer;
  white-space: nowrap;
}
.card-cta--secondary {
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.22);
  color: white;
}
.card-cta--secondary:hover { background: rgba(255,255,255,0.2) !important; }
.card-cta .ph { font-size: 14px; }
.ps-card--live:hover .card-cta:not(.card-cta--secondary) { background: #1e94c8; }

/* ── SOON FOOTER ── */
.soon-footer {
  display: flex; align-items: center; gap: 6px;
  margin-top: auto;
  font-size: 0.7rem; font-weight: 500; color: #94A3B8;
  padding: 9px 12px;
  background: #F8FAFC;
  border: 1px dashed #CBD5E1;
  border-radius: 8px;
}
.soon-footer .ph { font-size: 13px; }

/* ── TIP ── */
.ps-tip {
  display: flex; align-items: center; justify-content: center; gap: 5px;
  padding: 16px 0 8px; font-size: 0.68rem; color: #94A3B8;
}
.ps-tip .ph { font-size: 13px; }

/* ── RESPONSIVE ── */
@media (max-width: 600px) {
  .ps-shell { padding: 16px 14px; }
  .ps-grid  { grid-template-columns: 1fr; }
  .ps-hero-title { font-size: 1.2rem; }
}
</style>
